import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="site-header">
      <div className="container">
        <nav className="navbar">
          <div className="navbar-brand">
            <Link to="/" onClick={closeMenu}>
              <img 
                src="/logos/hero_logo.PNG" 
                alt="Fiesta del Tendero" 
                className="site-logo"
              />
            </Link>
          </div>
          
          <button className="hamburger-menu" onClick={toggleMenu}>
            <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
            <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
            <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
          </button>

          <div className={`navbar-nav ${isMenuOpen ? 'mobile-menu-open' : ''}`}>
            {isHomePage ? (
              <>
                <a href="#inicio" className="nav-link" onClick={closeMenu}>Inicio</a>
                <a href="#evento" className="nav-link" onClick={closeMenu}>El Evento</a>
                <a href="#marcas" className="nav-link" onClick={closeMenu}>Marcas</a>
                <a href="#galeria" className="nav-link" onClick={closeMenu}>Galería</a>
                <a href="https://acsware.co/lafiestadeltenderomagangue/" target="_blank" rel="noopener noreferrer" className="nav-link btn btn-secondary" onClick={closeMenu}>Registro</a>
              </>
            ) : (
              <>
                <Link to="/" className="nav-link" onClick={closeMenu}>Inicio</Link>
                <Link to="/politica-datos" className="nav-link" onClick={closeMenu}>Política de Datos</Link>
              </>
            )}
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;